import * as tslib_1 from "tslib";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Button, Progress, Upload } from "@h3/antd-vue";
import DataInfo from "./data-info.vue";
import { formApi, listApi as Application } from "@cloudpivot/api";
import { UploadControl } from "@cloudpivot/form/src/common/controls/upload-control";
import { utils } from "@cloudpivot/common";
import { filters } from '@cloudpivot/list/src/components/pc/components/model-table-import/filters';
Vue.use(Upload);
let DataImport = class DataImport extends Vue {
    constructor() {
        super(...arguments);
        this.fileList = [];
        this.file = {};
        this.isUploading = false;
        this.hasError = false;
        this.importLimitSize = 500; //子表Excel导入最大上限
        this.isHover = false;
        this.upLoadAccept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        this.progress = 10;
        this.timer = null;
    }
    get progressStatus() {
        if (this.progress !== 100) {
            return 'active';
        }
        return 'success';
    }
    mounted() {
        this.getImportLimit();
    }
    /**
     * 获取子表最大导入条数
     */
    getImportLimit() {
        formApi.getImportLimit({}).then((res) => {
            if (res.errcode === 0) {
                this.importLimitSize = Number(res.data) || 500;
            }
        });
    }
    /**
     * 判断上传的文件是否excel文件
     */
    beforeUpload(file) {
        return new Promise((resolve, reject) => {
            const suffixs = ["xlsx"];
            const suffix = this.getSuffix(file.name, false);
            if (this.fileList.length > 0) {
                this.fileList = this.fileList.slice(-1);
                this.$message.warning(this.$t('cloudpivot.list.pc.ImportTips11'));
                return reject(false);
            }
            if (suffixs.indexOf(suffix) > -1) {
                this.getSuffix(file.name, true);
                return resolve(true);
            }
            else {
                return reject(false);
            }
        });
    }
    getSuffix(fileName, showLoading) {
        const index = fileName.lastIndexOf(".");
        const suffix = fileName.substring(index + 1);
        if (suffix && showLoading) {
            this.isUploading = true;
            this.imitateProgress();
        }
        return suffix;
    }
    // 静态上传动画
    imitateProgress() {
        // const timer: any = null;
        // const vm: any = this;
        this.timer = setInterval(() => {
            this.progress += 10;
            if (this.progress === 90 && !this.file) {
                this.progress = 80;
            }
            if (this.progress === 100 && this.file) {
                clearInterval(this.timer);
                this.$emit('uploadComplete', true);
            }
        }, 100);
    }
    handleChange(info) {
        this.file = info.file;
        if (info.file.status !== "uploading") {
            this.fileList = info.fileList;
        }
        if (info.file.status === "done") {
            this.$emit("change", true);
            this.$emit("setFileName", info.file.response);
        }
        else if (info.file.status === "error") {
            this.isUploading = false;
            this.hasError = true;
        }
        else if (info.file.status === "removed") {
            //清除临时文件
            Application.deleteTemporaryFile({ fileName: info.file.name });
            this.$emit("change", false);
        }
    }
    deleteFile() {
        this.file = {};
        this.progress = 10;
        this.isUploading = false;
        this.fileList = [];
        clearInterval(this.timer); //清除临时文件
        Application.deleteTemporaryFile({ fileName: this.file.name });
        this.$emit('uploadComplete', false);
        this.$emit("change", false);
    }
    remove() {
        this.fileList = [];
        this.$emit("change", false);
    }
    get disabled() {
        return this.fileList.length > 0;
    }
    get header() {
        const token = localStorage.getItem("token");
        return {
            Authorization: `Bearer ${token}`,
        };
    }
    get uploadUrl() {
        return UploadControl.service.getListUploadUrl();
    }
    exportTemplate() {
        if (this.isPreview) {
            return this.$message.warning("预览不可下载");
        }
        let params = JSON.parse(JSON.stringify(this.sheetParams));
        //处理当子表嵌套在tab中的情况
        if (this.sheet.path) {
            let arr = [];
            this.sheet.path.forEach((p, i) => {
                if (i % 2 === 0) {
                    arr.push(p);
                }
            });
            params.subSchemaCode = arr.join(".");
        }
        formApi.exportTemplate(params).then((res) => {
            if (res.errcode === 0) {
                this.exportErrorResult(res.data, false);
            }
            else if (res.byteLength) {
                this.exportErrorResult(res, true);
            }
        });
    }
    exportErrorResult(file, isFlie) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = isFlie ? file : yield Application.exportErrorResult(file);
            if ((res.errcode && res.errcode !== 0) || res.byteLength < 100) {
                this.$message.error(this.$t("cloudpivot.list.pc.DownloadFailed"));
            }
            else {
                const blob = new Blob([res], { type: "application/vnd.ms-excel" });
                let sheetName = this.sheet.options.name_i18n
                    ? this.sheet.options.name_i18n[this.$i18n.locale]
                    : "";
                if (!sheetName) {
                    sheetName = this.sheet.options.name;
                }
                const fileName = sheetName +
                    this.$t("cloudpivot.form.renderer.importFile").toString() +
                    utils.DateHandle.dateFormat(new Date(), "YYYYMMDDHHmmss") +
                    ".xlsx";
                //清除临时文件
                if (!isFlie)
                    Application.deleteTemporaryFile({ fileName: file });
                this.downloadFile(blob, fileName);
            }
        });
    }
    downloadFile(blob, fileName) {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
        }
        else {
            const a = document.createElement("a");
            const url = URL.createObjectURL(blob);
            a.download = fileName;
            a.href = url;
            a.click();
            URL.revokeObjectURL(url);
        }
    }
};
tslib_1.__decorate([
    Prop()
], DataImport.prototype, "sheetParams", void 0);
tslib_1.__decorate([
    Prop()
], DataImport.prototype, "sheet", void 0);
tslib_1.__decorate([
    Inject()
], DataImport.prototype, "isPreview", void 0);
DataImport = tslib_1.__decorate([
    Component({
        name: "dataimport",
        filters: {
            // 根据不同大小显示 KB/MB
            filterFileSize: filters.fileSize,
        },
        components: {
            AButton: Button,
            AProgress: Progress,
            DataInfo,
            Upload,
        },
    })
], DataImport);
export default DataImport;
